<div [id]="data.id" 
    class="widget-area" 
    [ngClass]="data.isSelected ? 'form-unhighlited' : 'form-unhighlited'"
    cdkDropList
    [cdkDropListConnectedTo]="dropListIds"
    [cdkDropListData]="data.children"
    [cdkDropListEnterPredicate]="isDroppableWidget"
    (cdkDropListDropped)="onDrop($event)">
    <!-- Titlebar for Widget -->         
    <div *ngIf="!isMetadataView()" class="widget-top-bar" fxLayout="row nowrap"
        fxLayoutAlign="end start">
        <img class="form-icon" src="assets/img/icons/form.png"/>
        <mat-label class="form-title" fxFlex="grow" (click)="onSelect()" title="{{ getFormTitle() }}">{{ getFormTitle() }}</mat-label>
        <mat-icon *ngIf="!data.isContainerExpanded" class="top-icon" (click)="onSectionExpandAll()">expand_more</mat-icon>
        <mat-icon *ngIf="data.isContainerExpanded" class="top-icon" (click)="onSectionCollapseAll()">expand_less</mat-icon>
        <!-- <mat-icon *ngIf="data.isSelected" class="top-icon" (click)="onSelect()">check</mat-icon> -->
        <!-- <mat-icon *ngIf="isAdmin && !isPristine()" class="top-icon" (click)="resetPristine()">*</mat-icon>         -->
        <!-- <mat-icon class="top-icon" (click)="onDelete()">delete</mat-icon> -->
        <!-- <mat-icon *ngIf="!isMinimized" class="top-icon" (click)="onMinimize()">expand_less</mat-icon>
        <mat-icon *ngIf="isMinimized" class="top-icon" (click)="onMaximize()">expand_more</mat-icon> -->
        <!-- <mat-icon class="drag-handler" [matBadge]="data.badge">{{data.icon}}</mat-icon> -->
    </div>

    <!-- Config data for Widget -->
    <div *ngIf="!isMinimized" fxLayout="row nowrap">
        <appMetadataForm fxFlex="grow" [data]="data"></appMetadataForm>
    </div>

    <!-- Allowed drops -->
    <ng-container *ngFor="let widget of data.children">
        <ng-container [ngSwitch]="widget.widgetType">
            <div appWidgetsRow [data]="$any(widget)" [dropListIds]="dropListIds"
                (dropListIdAdded)="onDropListIdAdded($event)" *ngSwitchCase="WidgetsTypeEnum.ROW">
            </div>
            <!--            -->
            <div appWidgetsSection [data]="$any(widget)" [dropListIds]="dropListIds"
                (dropListIdAdded)="onDropListIdAdded($event)" *ngSwitchCase="WidgetsTypeEnum.SECTION">
            </div>
            <div appWidgetsQuestion [data]="$any(widget)" *ngSwitchCase="WidgetsTypeEnum.QUESTION">
            </div>
            <div appWidgetsText [data]="$any(widget)" *ngSwitchCase="WidgetsTypeEnum.TEXT">
            </div>
        </ng-container>
    </ng-container>
    <div class="dropping-area" *ngIf="isDeveloper()">
        <div class="dropp-area-text"  >Add a new section or drag & drop a question here</div>
    </div>
</div>